export const Columns = (() => {
	'use strict';

	function init() {

		

		var $orbs = $('.pxblock--columns .container .columns__rows .columns .orb');
		var $parallaxOrbs = $('.pxblock--columns .container .columns__rows .columns  .orb-parallax');

		function moveRandom(obj) {
		
			var topPos;
			var horPos;
	
			topPos = Math.floor(Math.random() * 90) + 1 + '%';
			horPos = Math.floor(Math.random() * 100) + 1 + '%';
	
			var leftObject = { 
				top: topPos,
				left: horPos
			  };
			
			var rightObject = { 
				top: topPos,
				right: horPos
			  };
	
			  if (obj.parent().hasClass('orbs__left')) {
				obj.css(rightObject);
			  }
			  
			  else {
				obj.css(leftObject);
			  }
	
			}
	
			$orbs.each(function() {
				moveRandom($(this));
				});	

				$parallaxOrbs.each(function() {
					moveRandom($(this));
					});	
	}

	return {
		init: init,
		name: 'columns'
	};
})();
